export default {
  props: {
    date: {
      type: Object,
      required: true
    },
    origin: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentMonth () {
      return this.date.format('MM')
    },
    currentYear () {
      return this.date.format('YYYY')
    },
    costs () {
      return this.origin.data.monthly_costs
    },
    saleRatio () {
      if (this.currentCost && this.advs > 0) {
        return this.currentCost.cost / this.advs
      } else {
        return null
      }
    },
    currentCost () {
      let costs = this.costs.filter(x => {
        let month = parseInt(x.month)
        let year = parseInt(x.year)
        return month === parseInt(this.currentMonth) && year === parseInt(this.currentYear)
      })

      if (costs && costs.length > 0) {
        let totalCost = costs.reduce((accum, val) => {
          return accum + val.cost
        }, 0)
        let totalMargin = costs.reduce((accum, val) => {
          return accum + val.margin
        }, 0)

        return {
          margin: totalMargin,
          cost: totalCost,
          month: costs[0].month,
          year: costs[0].year
        }
      }
      return null
    },
    margin () {
      if (this.currentCost) {
        return this.currentCost.margin - this.currentCost.cost
      } else {
        return null
      }
    },
    contactCost () {
      if (this.currentCost && this.contacts > 0) {
        return this.currentCost.cost / this.contacts
      } else {
        return null
      }
    },
    rdvCost () {
      if (this.currentCost && this.rdvs > 0) {
        return this.currentCost.cost / this.rdvs
      } else {
        return null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/OriginRowMixin.js